import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=85fe09dc&scoped=true&"
import script from "./forms.vue?vue&type=script&lang=js&"
export * from "./forms.vue?vue&type=script&lang=js&"
import style1 from "./forms.vue?vue&type=style&index=1&id=85fe09dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fe09dc",
  null
  
)

export default component.exports